"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateNumberArray = void 0;
const validationCore_1 = require("./validationCore");
const validationTypes_1 = require("./validationTypes");
const validateNumberArray = (arr, range, start, end) => {
    const firstIdx = start ?? 0;
    const limitIdx = end ?? arr.length;
    const res = {
        isValid: false,
        error: validationTypes_1.AttributeValidationError.INVALID_MEMBERS,
        invalidIndexes: [],
    };
    for (let idx = firstIdx; idx < limitIdx; idx++) {
        const validation = (0, validationCore_1.validAttributeNumberValue)(arr[idx], range);
        if (validation.error) {
            res.invalidIndexes.push(idx);
        }
    }
    if (res.invalidIndexes?.length === 0) {
        res.isValid = true;
        res.error = null;
    }
    return res;
};
exports.validateNumberArray = validateNumberArray;
